export const META_PIXEL_ID = '1046775378085845'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

/** Injects the official Meta Pixel snippet once and fires the initial PageView. */
export function initMetaPixel(pixelId: string = META_PIXEL_ID): void {
  if (typeof window === 'undefined' || window.fbq) return

  const fbq: Window['fbq'] = function (...args: unknown[]) {
    if (fbq!.callMethod) {
      fbq!.callMethod(...args)
    } else {
      fbq!.queue!.push(args)
    }
  } as NonNullable<Window['fbq']>

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  const noscript = document.createElement('noscript')
  const pixelImg = document.createElement('img')
  pixelImg.height = 1
  pixelImg.width = 1
  pixelImg.style.display = 'none'
  pixelImg.alt = ''
  pixelImg.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
  noscript.appendChild(pixelImg)
  document.body.appendChild(noscript)

  fbq('init', pixelId)
  fbq('track', 'PageView')
}

/** Fires a standard Meta Pixel event, no-op when the pixel has not loaded. */
export function trackPixelEvent(
  event: string,
  params?: Record<string, string | number>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, params)
}
